import PersonIndicator from './PersonIndicator'
import game from '../Game/GameInstance'

export default class ChildRoom
{

  constructor(data, parent) {

    this.data = data;
    this.people = [];

    this.id = data.id;
    this.parent = parent;

    this.image = data.image;
    this.image_url = data.image_url;
    this.name = data.name;

    this.personIndicator = new PersonIndicator(32,  {});
    game.layers.people.push(this.personIndicator);



  }

  getDoorPoint() {
    return this.parent.getDoorPoint();
  }

  addPerson(person) {

    let index = this.people.indexOf(person);
    if (index === -1) {

      this.people.push(person);
      this.parent.needsRendering = true;

    }

  }

  removePerson(person) {

    let index = this.people.indexOf(person);

    if (index === -1) {
      return;
    }

    this.people.splice(index, 1);

    this.parent.needsRendering = true;

  }


  garbageCollect()
  {

    if (this.personIndicator) {
      this.personIndicator.garbageCollect();
      this.personIndicator = null;
    }

  }


}
